var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833268 5.49375H10.1416L6.07493 1.42708C5.74993 1.10208 5.74993 0.56875 6.07493 0.24375C6.39993 -0.08125 6.92493 -0.08125 7.24993 0.24375L12.7416 5.73542C13.0666 6.06042 13.0666 6.58542 12.7416 6.91042L7.24993 12.4021C6.92493 12.7271 6.39993 12.7271 6.07493 12.4021C5.74993 12.0771 5.74993 11.5521 6.07493 11.2271L10.1416 7.16042H0.833268C0.374935 7.16042 -6.53101e-05 6.78542 -6.53101e-05 6.32708C-6.53101e-05 5.86875 0.374935 5.49375 0.833268 5.49375Z",
    fill: "#6A6DA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointerIcon);
export default __webpack_public_path__ + "static/media/pointer-icon.f93eda79.svg";
export { ForwardRef as ReactComponent };